import { CustomFieldDefinition } from '@alucio/aws-beacon-amplify/src/models';
import { FORM_SOURCE, Props } from './useCustomFormAdditionalSetting';
import { VEEVA_VAULT_TABLES } from '../../classes/CRM/CRMVeevaVaultTypes';

interface ADDITIONAL_HANDLER_TYPE {
  [table: string]: (props: Props) => Promise<CustomFieldDefinition[]>
}

const ADDITIONAL_SETTINGS_HANDLERS: ADDITIONAL_HANDLER_TYPE = {
  [VEEVA_VAULT_TABLES.MEDICAL_INSIGHT]: handleStandaloneMedicalInsights,
  [VEEVA_VAULT_TABLES.MEDICAL_INQUIRY]: handleStandaloneMedicalInquiry,
};

export const handleVeevaVaultAdditionalFormSettings = async (props: Props): Promise<CustomFieldDefinition[]> => {
  const handler = ADDITIONAL_SETTINGS_HANDLERS[props.standaloneForm?.apiName || ''];

  if (handler) {
    return handler(props);
  }

  return props.customFields;
}

//* MEDICAL INSIGHTS *//
async function handleStandaloneMedicalInsights(props: Props): Promise<CustomFieldDefinition[]> {
  // IF WE'RE CREATING A MEDICAL INSIGHT FROM A MEETING, THE INTERACTION FIELD GETS OMMITTED
  if (props.formSource === FORM_SOURCE.MEETING) {
    return props.customFields.filter((field) => field.fieldName !== 'interaction__v');
  }

  return props.customFields;
}

//* MEDICAL INQUIRY *//
async function handleStandaloneMedicalInquiry(props: Props): Promise<CustomFieldDefinition[]> {
  // IF WE'RE CREATING A MEDICAL INQUIRY FROM A MEETING, THE INTERACTION FIELD GETS OMMITTED
  if (props.formSource === FORM_SOURCE.MEETING) {
    return props.customFields.filter((field) => field.fieldName !== 'call2__v');
  }

  return props.customFields;
}
